export const estaCadastrandoCartao = ({ estaCadastrandoCartao }) => !!estaCadastrandoCartao
